exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-table[data-v-5f5f0ab2]{width:100%;border-collapse:collapse;margin:8px 0;font-size:.9em}.delivery-table>tbody>tr>td>span[data-v-5f5f0ab2]{font-size:1.2rem}.text-uppercase[data-v-5f5f0ab2]{text-transform:uppercase!important}", ""]);

// exports
